module.exports = __webpack_public_path__ + "img/newsletter1.c9abe769.png";